<table [dataSource]="dataSource" class="equipment-list-table dense-minimum mat-elevation-z8" mat-table>

  <!-- Checkbox Column -->
  <ng-container matColumnDef="select">
    <th *matHeaderCellDef mat-header-cell>
      <mat-checkbox (change)="$event ? toggleAllRows() : null"
                    [aria-label]="checkboxLabel()"
                    [checked]="selection.hasValue() && isAllSelected()"
                    [indeterminate]="selection.hasValue() && !isAllSelected()">
      </mat-checkbox>
    </th>
    <td *matCellDef="let row" mat-cell>
      <mat-checkbox (change)="$event ? selectionChange(row) : null"
                    (click)="$event.stopPropagation()"
                    [aria-label]="checkboxLabel(row)"
                    [checked]="selection.isSelected(row)">
      </mat-checkbox>
    </td>
  </ng-container>

  <ng-container matColumnDef="manufacturer">
    <th *matHeaderCellDef mat-header-cell>Mfr.</th>
    <td *matCellDef="let element" mat-cell> {{ element.manufacturer }}</td>
  </ng-container>

  <ng-container matColumnDef="sku">
    <th *matHeaderCellDef mat-header-cell>SKU</th>
    <td *matCellDef="let element" mat-cell> {{ element.sku }}</td>
  </ng-container>

  <ng-container matColumnDef="model">
    <th *matHeaderCellDef mat-header-cell>Model</th>
    <td *matCellDef="let element" mat-cell> {{ element.model }}</td>
  </ng-container>

  <ng-container matColumnDef="qty">
    <th *matHeaderCellDef mat-header-cell>Qty.</th>
    <td *matCellDef="let element" mat-cell> {{ element.quantity }}</td>
  </ng-container>

  <ng-container matColumnDef="status">
    <th *matHeaderCellDef mat-header-cell>Status</th>
    <td *matCellDef="let element" mat-cell>
      <app-equipment-status [equipment]="element" class="status"></app-equipment-status>
    </td>
  </ng-container>

  <ng-container matColumnDef="project">
    <th *matHeaderCellDef mat-header-cell>Project</th>
    <td *matCellDef="let element" mat-cell>
      <app-advanced-tooltip>
        <tooltip-body>
          @for (p of topLevelProjects(element); track p.id) {
            <a (click)="$event.stopPropagation()"
               [queryParams]="{eq: element.id}"
               [routerLink]="(element.assignedProjectIds.length == 1 ? element.assignedProjects[0] : p) | url"
               class="flex-row inline">
              <app-project-status [condense]="true"
                                  [project]="p"></app-project-status>
              <span>{{ p.name }}</span>
            </a>
          }
        </tooltip-body>
        @if (element.assignedProjectIds.length > 0) {
          <tooltip-popout>
            <div class="flex-row">
              @for (ap of element.assignedProjects; track ap.id; let last = $last) {
                <app-project-status [condense]="true" [project]="ap"></app-project-status> <span>{{ ap.name }}
                  @if (!last) {
                    ,
                  }
                </span>
              }
            </div>
          </tooltip-popout>
        }
      </app-advanced-tooltip>
    </td>
  </ng-container>

  <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
  <tr (click)="openEditDialog(row)" *matRowDef="let row; columns: displayedColumns;"
      [cdkContextMenuTriggerData]="{equipment:row}" [cdkContextMenuTriggerFor]="skuContext"
      mat-row>

    <ng-template #skuContext let-equipment="equipment">
      <div cdkMenu
           class="mat-mdc-menu-panel mdc-menu-surface mdc-menu-surface--open mat-elevation-z8">
        <div class="mat-mdc-menu-content mdc-list">
          <button (click)="copyToClipboard([equipment])" cdkMenuItem mat-menu-item>
            <mat-icon>content_copy</mat-icon>
            <span>Copy</span>
          </button>
          <button (click)="copyToClipboard(selection.selected)" [disabled]="selection.selected.length === 0"
                  cdkMenuItem
                  mat-menu-item>
            <mat-icon>copy_all</mat-icon>
            <span>Copy {{ selection.selected.length }} selected</span>
          </button>
        </div>
      </div>
    </ng-template>

  </tr>
</table>
